import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import Box from "@mui/material/Box";

const ApproveModal = ({ open, onClose, onApprove, proof_data }) => {
  const [selectedProofId, setSelectedProofId] = useState("");
  const [selectedProofOption, setSelectedProofOption] = useState("");

  const handleOptionChange = (event) => {
    const proofId = event.target.value;
    setSelectedProofId(proofId);

    // Find index to determine "Proof Option X"
    const index = proof_data.findIndex(
      (item) => item.id.toString() === proofId.toString(),
    );
    const letter = String.fromCharCode(65 + index);
    setSelectedProofOption(`Proof Option ${letter}`);
  };

  const handleApprove = () => {
    if (selectedProofId && selectedProofOption) {
      onApprove(selectedProofId, selectedProofOption);

    }
  };

  const getTabLabel = (index) => {
    const letter = String.fromCharCode(65 + index);
    return `Proof Option ${letter}`;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {},
      }}
    >
      <DialogTitle sx={{ fontWeight: 600, fontSize: "1.5rem" }}>
        Proof Approval
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Please select one proof for approval.
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup
              row
              value={selectedProofId}
              onChange={handleOptionChange}
            >
              {proof_data?.map((item, index) => (
                <FormControlLabel
                  key={item.id}
                  value={item.id}
                  control={<Radio />}
                  label={getTabLabel(index)}
                  sx={{ mr: 4 }}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            textTransform: "none",
            fontWeight: 500,
            backgroundColor: "#6c757d",
            color: "white",
            "&:hover": { backgroundColor: "#5a6268" },
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleApprove}
          color="success"
          disabled={!selectedProofId}
          sx={{
            textTransform: "none",
            fontWeight: 500,
            backgroundColor: "#198754",
            "&:hover": { backgroundColor: "#157347" },
          }}
        >
          Approve
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApproveModal;
